import React from 'react';
import { makeStyles, shorthands, mergeClasses, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    display: 'grid',
    gridTemplateColumns: '[first] auto [second] 40px [third]',
    gridTemplateRows: '[first] 24px [second] 20px [third] 20px [fourth]',
    ...shorthands.padding('5px'),
    ...shorthands.borderBottom('1px', 'solid', 'gray'),
    ...shorthands.borderTop('1px', 'solid', 'gray'),
    ':last-child': {
      borderBottom: 'unset',
    },
    cursor: 'pointer',
    ':hover': {
      backgroundColor: '#0000A00A',
    },
  },
  rootActive: {
    boxShadow: tokens.shadow4Brand,
    backgroundColor: '#ffffff',
  },
  title: {
    ...shorthands.gridArea(1, 1, 2, 3),
    fontSize: '18px',
  },
});

export default function AppPageListItem(
  props: React.PropsWithRef<{
    name: string;
    selected?: boolean;
    onClick?: () => void;
    rootRef: React.Ref<HTMLDivElement>;
  }>,
) {
  // const appState = useAppState();

  const styles = useStyles();

  return (
    <div
      className={mergeClasses(styles.root, props.selected && styles.rootActive)}
      onClick={props.onClick}
      ref={props.rootRef}
    >
      <div className={styles.title}>{props.name}</div>
    </div>
  );
}
